const ShowHideModuleOnLogin = {
	init() {
		this.ModulesToShow = this._findModulesToShow();
		this.ModulesToHide = this._findModulesToHide();

		this._subscribeActionsToLogin();
	},

	_findModulesToShow() {
		let HiddenModules = document.getElementsByClassName('ShowOnLogin');
		return HiddenModules;
	},

	_findModulesToHide() {
		let ShownModules = document.getElementsByClassName('HideOnLogin');
		return ShownModules;
	},

	_hideModule(ModuleToHide) {
		ModuleToHide.classList.add('Hidden');
	},

	_showModule(ModuleToShow) {
		ModuleToShow.classList.remove('Hidden');
	},

	_processModules(ModulesToShow, ModulesToHide) {
		for (let i = 0; i < ModulesToShow.length; i++) {
			this._showModule(ModulesToShow[i]);
		}

		for (let i = 0; i < ModulesToHide.length; i++) {
			this._hideModule(ModulesToHide[i]);
		}
	},

	_subscribeActionsToLogin() {
		if (window.AuthController === undefined) {
			return;
		}

		AuthController.subscribe((error, data) => {
			if (!data.LoggedInStatus) {
				return;
			}

			this._processModules(this.ModulesToShow, this.ModulesToHide);
		});
	}
};

ShowHideModuleOnLogin.init();
